
<nav class="navbar navbar-expand-lg bg-primary fixed-top navbar-transparent d-flex flex-column p-0 filter-nav" color-on-scroll="500">
  <div id="logo-bar" class="logo-bar" [ngClass]="{ 'hidden': isLogoBarHidden }">
    <div class="d-flex justify-content-between align-items-center w-100">
      <img src="assets/img/nav/header_new.png" alt="" (click)="routeTo('/home')" style="cursor: pointer; margin-left:-12px">
      <div class="d-flex">
        <div id="searchbar" class="search-container" (click)="openToTouch()">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" id="Isolation_Mode" data-name="Isolation Mode" viewBox="0 0 24 24"
              width="22" height="22">
              <path
                d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z">
              </path>
            </svg>
          </div>
          <input type="text" class="search-input" placeholder="Cerca" (keyup.enter)="onSearch($event)"/>
        </div>
        <!-- <div class="user-container ml-2 icon" style="cursor: pointer;">
          <i class="now-ui-icons users_single-02" style="font: 25px/1 Nucleo Outline; color: white;" ></i>
        </div> -->
      </div>
    </div>
  </div>
  <div class="container p-2">
    <div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler"
        aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation"
        (click)="openMobileNavbar()">
        <span class="navbar-toggler-bar bar1"></span>
        <span class="navbar-toggler-bar bar2"></span>
        <span class="navbar-toggler-bar bar3"></span>
      </button>
    </div>
    <div class="collapse navbar-collapse" data-nav-image="assets/img/blurred-image-1.jpg" data-color="orange">
      <ul class="navbar-nav w-100 d-flex justify-content-between">
        <li *ngFor="let element of linkList" class="nav-item" (click)="routeTo(element.href)" style="cursor: pointer;">
          <a class="nav-link" target="_blank" [ngClass]="{ 'active': currentRoute === element.href }">
            <!-- <i [class]="element.iconClass"></i> -->
            <p class="h4">{{ element.text }}</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>